import { FormService } from "./../services/form.service";
import { ResponseService } from "./../services/response.service";
import { LocalStorageService } from './../services/local-storage.service';
import { CompanyService } from "./../services/company.service";
import { NotificationsService } from "angular2-notifications";
import { Router } from "@angular/router";
import { ApiService } from "./../services/api.service";
import { CustomValidators } from "ng2-validation";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { CustomDSValidators } from "./../shared/validators/custom-validators";

@Component({
  selector: "app-add-company",
  templateUrl: "./add-company.component.html"
})
export class AddCompanyComponent implements OnInit {
  companyForm: FormGroup;

  public loading: boolean = false;

  public companyNameHint: boolean = false;
  public NIPHint: boolean = false;
  public postalCodeHint: boolean = false;

  public loadingCompanyData:boolean = false;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private notificationsService: NotificationsService,
    private localStorageService: LocalStorageService,
    private companyService: CompanyService,
    private responseService: ResponseService,
    private formService: FormService
  ) {
    const controls = {
      name: new FormControl(""),
      nip: new FormControl(""),
      street: new FormControl(""),
      country_id: new FormControl("518"),
      street_hn: new FormControl(""),
      street_ln: new FormControl(""),
      postal_code: new FormControl(""),
      city: new FormControl("")
    };

    const validators = {
      name: [Validators.required],
      nip: [Validators.required, CustomDSValidators.nip],
      street: [],
      country_id: [Validators.required],
      street_hn: [Validators.required],
      street_ln: [],
      postal_code: [Validators.required, CustomDSValidators.polishPostalCode],
      city: [Validators.required]
    };

    this.companyForm = this.formService.buildForm(controls, validators);
  }

  ngOnInit() {
    this.companyForm.validator
  }

  loadCompany(): void {
    if(this.companyForm.controls['nip'].errors === null){
      this.loadingCompanyData = true;
      this.apiService.get('/company/nipapi/' + this.companyForm.controls['nip'].value).subscribe(
        (response) => {
          this.loadingCompanyData = false;
          const companyData = this.responseService.success(false, response, 'company');
          this.companyForm.patchValue(companyData);
        },
        (error) => {
          this.loadingCompanyData = false;
        }
      );
    }
  }

  addCompany(): void {
    this.apiService.post("/company", this.companyForm.value).subscribe(
      response => {
        const companyData = this.responseService.success(
          true,
          response,
          "company",
          "create"
        );
        this.localStorageService.set("company", companyData.id);
        this.companyService.selectedCompany = companyData;

        setTimeout(function() {
          location.href = "/panel";
        }, 300);
      },
      error => {
        this.responseService.error(error, this.companyForm);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/company-view/add-company.component.ts